module.exports = __webpack_public_path__ + "static/media/undraw-tennis.f3939a41.svg";